var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5431 16.3381L21.6689 10.1803L21.6934 10.1546C21.4968 10.0516 21.2512 10 21.0054 10H6.99953C6.75374 10 6.53262 10.0516 6.31152 10.1546L13.4619 16.3382C13.7814 16.5959 14.2236 16.5959 14.5431 16.3382L14.5431 16.3381Z",
    fill: "#001636",
    fillOpacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2801 10.9539L15.1543 17.1118C14.8103 17.3953 14.4171 17.5498 13.9994 17.5498C13.5818 17.5498 13.1886 17.3953 12.8446 17.1118L5.69422 10.9282C5.66971 10.9025 5.62052 10.8509 5.59601 10.8252C5.47312 11.057 5.39941 11.3405 5.39941 11.6498V20.9253C5.39941 21.8528 6.1119 22.5999 6.99649 22.5999H21.0023C21.8869 22.5999 22.5994 21.8528 22.5994 20.9253V11.6498C22.5994 11.3406 22.5257 11.0572 22.3783 10.8252C22.3538 10.8766 22.3293 10.9282 22.2801 10.9539L22.2801 10.9539Z",
    fill: "#001636",
    fillOpacity: 0.92
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.971d4617ae15543cff3a99e747c02001.svg";
export { ForwardRef as ReactComponent };